<template>
  <v-card
    class="pa-0 rounded-0 elevation-0"
    :class="$vuetify.theme.dark ? 'blue-darken-5' : 'white-lighten-2'"
  >
    <v-sheet
      class="transactionTable marketingTable"
      :class="$vuetify.theme.dark ? 'blue-darken-5 ' : 'white-lighten-1'"
    >
      <v-card-text class="d-flex justify-space-between px-3 pb-5">
        <v-card-title class="pa-0"> Banner Size </v-card-title>
        <v-dialog
          transition="scale-transition"
          origin="center center"
          max-width="324"
          v-model="dialog"
          content-class="deposit-withdraw-popup marketingPopup"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              tile
              small
              v-bind="attrs"
              v-on="on"
              elevation="0"
              class="text-capitalize btn-account"
              color="teal-lighten-1"
              >+ New Size</v-btn
            >
          </template>

          <v-card
            class="rounded-0 pa-7"
            :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'"
          >
            <v-card-title class="pb-3 text-left justify-start pl-3">
              New Banner Size
            </v-card-title>
            <v-card-subtitle class="mt-0 pl-3 pb-0 pr-10 text--ash">
              You Can Create Your New Banner Size From Here.
            </v-card-subtitle>
            <v-card
              class="deposit-form px-3 py-4"
              :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'"
            >
              <v-row>
                <v-col cols="12">
                  <fieldset>
                    <legend>Category</legend>
                    <v-select
                      v-model="newselectedCategoryId"
                      solo
                      :items="categoryOptions"
                      item-value="id"
                      item-text="text"
                      append-icon="mdi-chevron-down"
                      label="Click to Select"
                      class="custom-select"
                      hide-details
                    ></v-select>
                  </fieldset>
                </v-col>
                <v-col cols="12">
                  <fieldset>
                    <legend>Banner Width</legend>
                    <v-text-field
                      v-model="newbannerWidth"
                      type="number"
                      label="Enter Banner Width"
                      single-line
                      solo
                      hide-details
                      class="custom-select"
                    ></v-text-field>
                  </fieldset>
                </v-col>
                <v-col cols="12">
                  <fieldset>
                    <legend>Banner Height</legend>
                    <v-text-field
                      v-model="newbannerHeight"
                      type="number"
                      label="Enter Banner Height"
                      single-line
                      solo
                      hide-details
                      class="custom-select"
                    ></v-text-field>
                  </fieldset>
                </v-col>
              </v-row>
            </v-card>
            <v-card-actions>
              <v-row dense>
                <v-col cols="6">
                  <v-btn
                    tile
                    block
                    @click="newBannerSize"
                    :loading="isLoading"
                    :disabled="isLoading"
                    elevation="0"
                    class="text-capitalize btn-account"
                    color="teal-lighten-1"
                    >Save</v-btn
                  >
                </v-col>
                <v-col cols="6">
                  <v-btn
                    tile
                    block
                    outlined
                    @click="dialog = false"
                    elevation="0"
                    class="text-capitalize btn-account"
                    >Close</v-btn
                  >
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-text>
      <v-data-table
        :items-per-page="10"
        :headers="headers"
        :items="bannerSizes"
      >
        <template v-slot:item.action="{ item }">
          <div class="trade-dropdown">
            <v-menu
              rounded="0"
              class="trade-dropdown-menu"
              transition="slide-x-transition"
              bottom
              left
            >
              <template v-slot:activator="{ attrs, on }">
                <v-btn
                  small
                  tile
                  elevation="0"
                  class="ma-0 text-capitalize btn-account"
                  v-bind="attrs"
                  v-on="on"
                  icon
                >
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-card class="dropdown-menu-card" tile flat>
                <v-list
                  flat
                  elevation="0"
                  :class="
                    $vuetify.theme.dark ? '$blue-darken-1' : 'white-lighten-1'
                  "
                >
                  <v-list-item-group>
                    <v-list-item :ripple="false">
                      <v-list-item-content>
                        <!-- EDIT -->
                        <v-dialog
                          transition="scale-transition"
                          origin="center center"
                          max-width="324"
                          v-model="editDialog"
                          content-class="deposit-withdraw-popup marketingPopup"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              tile
                              small
                              v-bind="attrs"
                              v-on="on"
                              elevation="0"
                              class="text-capitalize btn-account"
                              color="teal-lighten-1"
                              >Edit</v-btn
                            >
                          </template>

                          <v-card
                            class="rounded-0 pa-7"
                            :class="
                              $vuetify.theme.dark
                                ? 'blue-darken-1'
                                : 'white-lighten-5'
                            "
                          >
                            <v-card-title
                              class="pb-3 text-left justify-start pl-3"
                            >
                              Edit Banner Size
                            </v-card-title>
                            <v-card-subtitle
                              class="mt-0 pl-3 pb-0 pr-10 text--ash"
                            >
                              You Can Update Banner Size From Here.
                            </v-card-subtitle>
                            <v-card
                              class="deposit-form px-3 py-4"
                              :class="
                                $vuetify.theme.dark
                                  ? 'blue-darken-1'
                                  : 'white-lighten-5'
                              "
                            >
                              <v-row>
                                <v-col cols="12">
                                  <fieldset>
                                    <legend>Category</legend>
                                    <v-select
                                      v-model="editselectedCategoryId"
                                      solo
                                      :items="categoryOptions"
                                      item-value="id"
                                      item-text="text"
                                      append-icon="mdi-chevron-down"
                                      label="Click to Select"
                                      class="custom-select"
                                      hide-details
                                    ></v-select>
                                  </fieldset>
                                </v-col>
                                <v-col cols="12">
                                  <fieldset>
                                    <legend>Banner Width</legend>
                                    <v-text-field
                                      v-model="editbannerWidth"
                                      type="number"
                                      label="Enter Banner Width"
                                      single-line
                                      solo
                                      hide-details
                                      class="custom-select"
                                    ></v-text-field>
                                  </fieldset>
                                </v-col>
                                <v-col cols="12">
                                  <fieldset>
                                    <legend>Banner Height</legend>
                                    <v-text-field
                                      v-model="editbannerHeight"
                                      type="number"
                                      label="Enter Banner Height"
                                      single-line
                                      solo
                                      hide-details
                                      class="custom-select"
                                    ></v-text-field>
                                  </fieldset>
                                </v-col>
                              </v-row>
                            </v-card>
                            <v-card-actions>
                              <v-row dense>
                                <v-col cols="6">
                                  <v-btn
                                    tile
                                    block
                                    @click="editBannerSize(item?.id)"
                                    elevation="0"
                                    class="text-capitalize btn-account"
                                    color="teal-lighten-1"
                                    >Save</v-btn
                                  >
                                </v-col>
                                <v-col cols="6">
                                  <v-btn
                                    tile
                                    block
                                    outlined
                                    @click="editDialog = false"
                                    elevation="0"
                                    class="text-capitalize btn-account"
                                    >Close</v-btn
                                  >
                                </v-col>
                              </v-row>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                        <!-- DELETE -->
                        <v-dialog
                          transition="scale-transition"
                          origin="center center"
                          max-width="324"
                          v-model="deleteDialog"
                          content-class="deposit-withdraw-popup marketingPopup"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              tile
                              small
                              v-bind="attrs"
                              v-on="on"
                              elevation="0"
                              class="text-capitalize btn-account"
                              color="teal-lighten-1"
                              >Delete</v-btn
                            >
                          </template>

                          <v-card
                            class="rounded-0 pa-7"
                            :class="
                              $vuetify.theme.dark
                                ? 'blue-darken-1'
                                : 'white-lighten-5'
                            "
                          >
                            <v-card-title
                              class="pb-3 text-left justify-start pl-3"
                            >
                              Delete Banner
                            </v-card-title>
                            <v-card-subtitle
                              class="mt-0 pl-3 pb-0 pr-10 text--ash"
                            >
                              Do you want to delete?
                            </v-card-subtitle>
                            <v-card-actions>
                              <v-row dense>
                                <v-col cols="6">
                                  <v-btn
                                    tile
                                    block
                                    @click="deletebannerSize(item?.id)"
                                    elevation="0"
                                    class="text-capitalize btn-account"
                                    color="teal-lighten-1"
                                    >Delete</v-btn
                                  >
                                </v-col>
                                <v-col cols="6">
                                  <v-btn
                                    tile
                                    block
                                    outlined
                                    @click="deleteDialog = false"
                                    elevation="0"
                                    class="text-capitalize btn-account"
                                    >Cancel</v-btn
                                  >
                                </v-col>
                              </v-row>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-menu>
          </div>
        </template>
        <template v-slot:item.sl="{ item, index }">
          {{ index + 1 }}
        </template>
        <template v-slot:item.resolution="{ item }">
          {{ item?.width }}{{ "*" }}{{ item?.height }}
        </template>
      </v-data-table>
    </v-sheet>
  </v-card>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { MARKETTINGTOOLS__ACTIONS } from "@/store/action-types";
import toast from "@/services/Notification";

export default {
  data() {
    return {
      headers: [
        { text: "SL", align: "start", value: "sl" },
        { text: "Category", value: "category_name" },
        { text: "Resolution", value: "resolution" },
        { text: "Action", value: "action" },
      ],
      dialog: false,
      editDialog: false,
      deleteDialog: false,
      newselectedCategoryId: null,
      isLoading: false,
      newbannerWidth: "",
      newbannerHeight: "",
      editselectedCategoryId: null,
      editbannerWidth: "",
      editbannerHeight: "",
    };
  },
  computed: {
    ...mapState("markettingtools", ["bannerSizes", "bannerCategories"]),
    categoryOptions() {
      return this.bannerCategories.map((category) => ({
        id: category.id,
        text: category.category_name,
      }));
    },
  },
  methods: {
    ...mapActions("markettingtools", [
      MARKETTINGTOOLS__ACTIONS.BANNERCATEGORIES,
      MARKETTINGTOOLS__ACTIONS.BANNERSIZES,
      MARKETTINGTOOLS__ACTIONS.BANNERSIZECREATE,
      MARKETTINGTOOLS__ACTIONS.BANNERSIZEUPDATE,
      MARKETTINGTOOLS__ACTIONS.BANNERSIZEDELETE,
    ]),

    async newBannerSize() {
      try {
        if (!this.newselectedCategoryId) {
          toast.error("Please select a category!");
          return;
        }
  
        if (!this.newbannerWidth) {
          toast.error("Please select a width!");
          return;
        }
  
        if (!this.newbannerHeight) {
          toast.error("Please select a height!");
          return;
        }
  
        if (this.newbannerWidth) {
          if (this.newbannerWidth < 32) {
            toast.error("Width must be equal or greater than 32.");
            return;
          }
        }
  
        if (this.newbannerHeight) {
          if (this.newbannerHeight < 32) {
            toast.error("height must be equal or greater than 32.");
            return;
          }
        }
  
        const parameter = {
          categoryId: Number(this.newselectedCategoryId),
          width: Number(this.newbannerWidth),
          height: Number(this.newbannerHeight),
        };
        
        this.isLoading = true;
        await this[MARKETTINGTOOLS__ACTIONS.BANNERSIZECREATE](parameter);
        this.dialog = false;
        this.newselectedCategoryId = null;
        this.newbannerWidth = "";
        this.newbannerHeight = "";
      } catch(error) {
        console.log("error updating banner size")
      } finally {
        this.isLoading = false;
      }
    },

    editBannerSize(id) {
      if (this.editbannerWidth) {
        if (this.editbannerWidth < 32) {
          toast.error("Width must be equal or greater than 32.");
          return;
        }
      }

      if (this.editbannerHeight) {
        if (this.editbannerHeight < 32) {
          toast.error("height must be equal or greater than 32.");
          return;
        }
      }

      const parameter = {
        id: id,
        categoryId: this.editselectedCategoryId,
        width: this.editbannerWidth,
        height: this.editbannerHeight,
      };

      this[MARKETTINGTOOLS__ACTIONS.BANNERSIZEUPDATE](parameter);
      this.editDialog = false;
      this.editselectedCategoryId = null;
      this.editbannerWidth = "";
      this.editbannerHeight = "";
    },

    deletebannerSize(id) {
      const parameter = {
        id: id,
      };

      this[MARKETTINGTOOLS__ACTIONS.BANNERSIZEDELETE](parameter);
      this.deleteDialog = false;
    },
  },

  mounted() {
    this[MARKETTINGTOOLS__ACTIONS.BANNERCATEGORIES]();
    this[MARKETTINGTOOLS__ACTIONS.BANNERSIZES]();
  },
};
</script>
